<template>
	<div class="xs-12 p4">
		<!-- Buttons -->
		<div class="flex mt1 mb6">
			<j-button type="tertiary" @click="codeOrWithoutCode = 'withoutCode'">{{
				$t("manually")
			}}</j-button>
			<j-button
				class="ml8"
				type="tertiary"
				@click="codeOrWithoutCode = 'code'"
				>{{ $t("discount_code") }}</j-button
			>
		</div>

		<!--Discount code -->
		<core-form-input
			class="mt6"
			v-if="codeOrWithoutCode === 'code'"
			componentName="j-base-input-text"
			name="code"
			:label="$t('discount_code')"
			v-validate="'required'"
			v-model="code"
			:validationErrors="errors"
		/>

		<!-- Ad hoc discount without discount code -->
		<div v-else class="flex wrap">
			<!-- Name -->
			<core-form-input
				class="xs-12 mb4"
				componentName="j-base-input-text"
				:label="$t('name')"
				v-model="name"
			/>

			<div class="xs-4">
				<core-form-input
					componentName="j-base-radios"
					name="flatOrRatio"
					:label="$t('select')"
					v-model="flatOrRatio"
					:options="[
						{ name: $t('percentage'), value: 'ratio' },
						{ name: $t('flat'), value: 'flat' }
					]"
				></core-form-input>
			</div>

			<!-- Flat -->
			<div class="flex xs-8" v-if="flatOrRatio === 'flat'">
				<core-form-input
					componentName="j-base-input-number"
					name="discountFlat"
					:label="$t('flat')"
					v-model="discountFlat"
				></core-form-input>
			</div>

			<!-- Ratio -->
			<div v-else class="xs-8 flex wrap">
				<div class="xs-11">
					<core-form-input
						componentName="j-base-input-number"
						name="discountPercentage"
						v-model="discountPercentage"
						:label="$t('percentage')"
					></core-form-input>
				</div>
			</div>
			<!-- Order -->
			<div class="xs-12 mt4">
				<core-form-input
					componentName="j-base-input-number"
					:label="$t('order')"
					v-model="order"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"

export default {
	name: "AddUpdateDiscount",
	components: {
		CoreFormInput,
		JButton
	},
	props: {
		value: Object
	},
	data() {
		return {
			discountPercentage: 0,
			discountFlat: 0,
			name: null,
			flatOrRatio: "ratio",
			code: null,
			order: 0,
			codeOrWithoutCode: "withoutCode"
		}
	},
	watch: {
		discountPercentage(newValue) {
			if (newValue) {
				const calculationJsonLogic = this.buildJsonLogic({
					flatOrRatio: "ratio",
					discountPercentage: newValue
				})
				this.$emit("input", {
					...this.value,
					calculationJsonLogic
				})
			} else {
				this.$emit("input", {
					...this.value,
					calculationJsonLogic: undefined
				})
			}
		},
		discountFlat(newValue) {
			if (newValue) {
				const calculationJsonLogic = this.buildJsonLogic({
					flatOrRatio: "flat",
					discountFlat: newValue
				})
				this.$emit("input", {
					...this.value,
					calculationJsonLogic
				})
			} else {
				this.$emit("input", {
					...this.value,
					calculationJsonLogic: undefined
				})
			}
		},
		flatOrRatio(newValue) {
			if (
				newValue &&
				((newValue === "ratio" && this.discountPercentage) ||
					(newValue === "flat" && this.discountFlat))
			) {
				const calculationJsonLogic = this.buildJsonLogic({
					flatOrRatio: newValue
				})
				this.$emit("input", {
					...this.value,
					calculationJsonLogic
				})
			} else {
				this.$emit("input", {
					...this.value,
					calculationJsonLogic: undefined
				})
			}
		},
		codeOrWithoutCode(newVal) {
			if (newVal === "code") {
				this.$emit("input", {
					...this.value,
					withCode: true
				})
			} else if (newVal === "withoutCode") {
				this.$emit("input", {
					...this.value,
					withCode: false
				})
			}
		},
		code(newValue) {
			this.$emit("input", {
				...this.value,
				code: newValue
			})
		},
		order(newValue) {
			this.$emit("input", {
				...this.value,
				order: newValue
			})
		},
		name(newValue) {
			this.$emit("input", {
				...this.value,
				name: newValue
			})
		}
	},
	created() {
		if (this.value.calculationJsonLogic) {
			try {
				const parsedJsonLogic = JSON.parse(this.value.calculationJsonLogic)
				if (
					parsedJsonLogic["-"] &&
					typeof parsedJsonLogic["-"]?.[1] === "number"
				) {
					this.flatOrRatio = "flat"
					this.discountFlat = parsedJsonLogic["-"][1]
				}
				if (
					parsedJsonLogic["*"] &&
					typeof parsedJsonLogic["*"]?.[1] === "number"
				) {
					this.flatOrRatio = "ratio"
					this.discountPercentage = (
						100 -
						parsedJsonLogic["-"][1] * 100
					).toFixed(2)
				}
			} catch (error) {
				this.flatOrRatio = "ratio"
			}
		}
		if (this?.value?.order) this.order = this.value.order
	},
	methods: {
		buildJsonLogic({ flatOrRatio, discountFlat, discountPercentage }) {
			return flatOrRatio === "flat"
				? `{ "-": [ {"var": "premium"}, ${discountFlat || this.discountFlat}]}`
				: `{ "*": [ {"var" : "premium"}, ${(100 - discountPercentage ||
						this.discountPercentage) / 100} ]}`
		}
	}
}
</script>

<style></style>
